module.exports = __webpack_public_path__ + "static/media/lose.550e2300.png";